"use client";
import { AdaptiveImage } from "@/components/common/AdaptiveImage";
import { ImageZoom, Typo } from "@repo/ui/components";
import { formatDate } from "date-fns";
import { useEffect, useState } from "react";

interface MissionRewardSectionProps {
  rewardImageUrl?: string;
  rewardName?: string;
  rewardDescription?: string;
  rewardScheduledDate?: Date;
}

export function MissionRewardSection({
  rewardImageUrl,
  rewardName,
  rewardDescription,
  rewardScheduledDate,
}: MissionRewardSectionProps) {
  const [formattedScheduledDate, setFormattedScheduledDate] = useState<string | null>(null);

  useEffect(() => {
    if (rewardScheduledDate) {
      setFormattedScheduledDate(formatDate(rewardScheduledDate, "yy.MM.dd"));
    }
  }, [rewardScheduledDate]);

  return (
    <div className="flex flex-col items-center rounded-2xl bg-white px-2 py-3 shadow-[0px_4px_20px_0px_rgba(9,9,11,0.08)]">
      <div className="flex flex-1 flex-col items-center gap-2">
        {rewardImageUrl && (
          <ImageZoom src={rewardImageUrl}>
            <div className="size-[120px] overflow-hidden rounded-xl bg-zinc-50">
              <AdaptiveImage src={rewardImageUrl} alt="reward" className="size-full rounded-xl" />
            </div>
          </ImageZoom>
        )}
        <div className="flex flex-col items-center w-full text-center">
          {rewardName && (
            <Typo.SubTitle size="large" className="truncate w-full">
              {rewardName}
            </Typo.SubTitle>
          )}
          {rewardDescription && (
            <Typo.Body size="medium" className="truncate w-full text-zinc-500">
              {rewardDescription}
            </Typo.Body>
          )}
        </div>
        {formattedScheduledDate && (
          <div className="rounded-[6px] border border-zinc-200 px-2 py-1">
            <Typo.Body size="small" className="text-zinc-500">
              {`${formattedScheduledDate} 순차 지급`}
            </Typo.Body>
          </div>
        )}
      </div>
    </div>
  );
}
